import { Box, Button } from '@mui/material';
import { useState } from 'react';
import { useTranslation } from 'react-i18next';
import { GenericDialog } from 'src/shared/components/organisms/genericDialog';
import { PersonAdd } from '@mui/icons-material';
import ConsoleHelper from 'src/shared/functions/consoleHelper';
import { Member } from '../models/member';
import { MemberFamilyDataGrid } from './memberFamilyDataGrid';
import { MemberFamilyCreateCouplingModal } from './memberFamilyCreateCouplingModal';
import { MemberFamilyDeleteFamilyModal } from './memberFamilyDeleteFamilyModal';

type MemberFamilyEditModalProps = {
  modalOpen: boolean;
  onClose: () => void;
  refetchMemberCallback: () => void;
  member: Member;
};

export const MemberFamilyEditModal = (props: MemberFamilyEditModalProps) => {
  const { modalOpen, onClose, member, refetchMemberCallback } = props;
  const { t } = useTranslation(['member']);

  const [openCouplingModal, setOpenCouplingModal] = useState(false);
  const [openDeletModal, setOpenDeletModal] = useState(false);

  const onCloseHandler = () => {
    onClose();
  };

  const refetchMemberCallbackHandler = () => {
    setOpenCouplingModal(false);
    setOpenDeletModal(false);
    refetchMemberCallback();
    onClose();
  };

  ConsoleHelper.log(member);

  const mainMember = member.familyMembers?.find((mem) => mem.mainMember);

  return (
    <>
      <GenericDialog
        open={modalOpen}
        onClose={onCloseHandler}
        onSave={() => ConsoleHelper.log('save')}
        dialogTitle={`${t('member:editFamily.header')} (${t('member:member')} #${member.memberNr})`}
        dialogSubTitle={`${member.firstName} ${member.lastName}`}
        padding={0}
        dialogContent={<MemberFamilyDataGrid memberId={mainMember?.member_id ?? 0} />}
        dialogActions={
          <Box display='flex' flexDirection='row' justifyContent='space-between' width='100%'>
            <Button variant='outlined' color='primary' disableElevation onClick={() => setOpenDeletModal(true)} sx={{ mr: 1 }}>
              {t('member:button.deleteFamily')}
            </Button>
            <Button
              autoFocus
              variant='contained'
              color='secondary'
              startIcon={<PersonAdd />}
              disableElevation
              onClick={() => setOpenCouplingModal(true)}
            >
              {t('member:button.addCoupling')}
            </Button>
          </Box>
        }
      />
      <MemberFamilyCreateCouplingModal
        modalOpen={openCouplingModal}
        onClose={() => setOpenCouplingModal(false)}
        refetchMemberCallback={refetchMemberCallbackHandler}
        memberAssociationId={member.association?.localAss_id ?? 0}
        memberId={mainMember?.member_id ?? 0}
        mainMemberLocalAssId={mainMember?.localAss_id ?? 0}
      />
      <MemberFamilyDeleteFamilyModal
        modalOpen={openDeletModal}
        onClose={() => setOpenDeletModal(false)}
        onDeleteSuccess={refetchMemberCallbackHandler}
        memberId={mainMember?.member_id ?? 0}
      />
    </>
  );
};
